// extracted by css-extract-rspack-plugin
var _1 = "lo";
var _2 = "ln";
var _3 = "lq";
var _4 = "fl";
var _5 = "e0";
var _6 = "lp";
export { _1 as "comma", _2 as "pageTagsComponent", _3 as "tags", _4 as "text", _5 as "title", _6 as "titleDescription" }
